import { useCallback, useState } from 'react';
import { OnChangeFn, PaginationState } from '@tanstack/react-table';
import { TableStateManager } from '@common/components/table/types';

export function useControlledPagination({
  initialPageSize = 10,
  tableStateManager,
}: {
  initialPageSize: number;
  tableStateManager: TableStateManager;
}) {
  const [paginationState, setPaginationState] =
    tableStateManager.usePaginationState({
      pageIndex: 0,
      pageSize: initialPageSize,
    });

  // Call this when filters or sorting change to return to page 0
  const resetPagination = useCallback(() => {
    setPaginationState((old: PaginationState) => ({ ...old, pageIndex: 0 }));
  }, [setPaginationState]);

  const onPaginationChange: OnChangeFn<PaginationState> = useCallback(
    (stateUpdater) => {
      setPaginationState(stateUpdater);
    },
    [setPaginationState],
  );

  return { paginationState, onPaginationChange, resetPagination };
}
